/**
 * Ukrainian presence presentation helpers.
 * Gender is unavailable on current user payloads — use neutral wording.
 */

function pad2(n) {
  return String(n).padStart(2, "0");
}

export function formatPresenceTimestamp(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return (
    pad2(d.getHours())
    + ":"
    + pad2(d.getMinutes())
    + " "
    + pad2(d.getDate())
    + "."
    + pad2(d.getMonth() + 1)
    + "."
    + d.getFullYear()
  );
}

/**
 * @returns {{ kind: 'online'|'last_seen'|'none', text: string|null }}
 */
export function formatPresenceStatus(presence) {
  if (!presence || typeof presence !== "object") {
    return { kind: "none", text: null };
  }
  if (presence.online === true) {
    return { kind: "online", text: "Онлайн" };
  }
  if (presence.online === false && presence.lastSeenAt) {
    const stamp = formatPresenceTimestamp(presence.lastSeenAt);
    if (!stamp) {
      return { kind: "none", text: null };
    }
    return {
      kind: "last_seen",
      text: "Востаннє в мережі " + stamp,
    };
  }
  return { kind: "none", text: null };
}

/** Map store presence → ProfileIdentity/Avatar props without fabricating Offline. */
export function presenceToProfileProps(presence) {
  const status = formatPresenceStatus(presence);
  if (status.kind === "online") {
    return { isOnline: true, lastSeen: null };
  }
  if (status.kind === "last_seen") {
    return { isOnline: false, lastSeen: presence.lastSeenAt };
  }
  return { isOnline: null, lastSeen: null };
}
